/*
 *  *
 *  *  * Copyright (c) 2023 Hg Digital, Setera
 *  *  *************************************************************
 *  *  *Projeto  : setera-web
 *  *  *Autor    : diegobrock
 *  *  *Data     : 05/07/2023 11:08
 *  *  *Empresa  : HG Digital/Setera
 *  *  *************************************************************
 *  *
 */

import {Link} from './link';

export class BaseModel {
    links?: Link[];
}
